import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { GridApi, GridOptions, RowGroupingDisplayType } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { LookupService } from '../services/lookup.service';
import { BusinessEntityService } from '../services/business-entity.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssumedRoleStoreService } from '../services/assumed-role-store.service';
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.css'
})
export class AdminComponent implements OnInit{
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  selectedTabIndex=0;
  domLayout='autoHeight';
  gridApi: GridApi;
  gridColumnApi: any;
  groupDisplayType: RowGroupingDisplayType = "groupRows";
  gridOptions: GridOptions = {
    onGridReady: (params) => this.onGridReady(params)
  };
  employeeId: number;
  loginUserName: string;
  loginUserRole: string;
  displayUnauthorized: boolean;
  cancelAssumedUser: boolean;
  displayScreen: boolean;
  checkValidity: any;
  constructor(
    public lookup:LookupService, private readonly bservice: BusinessEntityService,private readonly router: Router,
    private readonly ngxSpinner: NgxSpinnerService, private readonly assumeRole: AssumedRoleStoreService
    ) { }

  ngOnInit() {    
    this.ngxSpinner.show();
    this.checkValidity = this.lookup.localStorageData.subscribe(async data => { 
      if(data?.includes('success')){
        this.displayUnauthorized = false;
        this.displayScreen = true;
        this.employeeId=this.bservice.loggedUserEmployeeId;
        this.loginUserName = this.bservice.loggedUserEmployeenameOriginal;
        const localStorageAssumeUser= JSON.parse(localStorage.getItem('userAssumed'));
        if(localStorageAssumeUser){
          this.assumeRole.assumeRoleByLocalStorage(localStorageAssumeUser)
        }else{
          this.assumeRole.assumeRoleByBService()
        }
        if (!this.assumeRole.isAdmin) { //If logged user is not Admin, navigate to home screen
          this.router.navigate(['./home']);
        }
        this.ngxSpinner.hide();
		  } else if(data?.includes('failure')) {
        this.displayUnauthorized = true;
        this.displayScreen = false;
        const localStorageAssumeUser = localStorage.getItem('userAssumedData');
        if (localStorageAssumeUser==='noData') {
          this.cancelAssumedUser = true;
        }
        this.ngxSpinner.hide();
      }
    })
  }
  
  onTabChanged(_event: MatTabChangeEvent) {
    //NO Sonar
  }

  icons = {
    menu: ' ',
    filter: ' '
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  @HostListener("window:resize", ['$event'])
  onResize(_event) {
    if (this.gridApi != null) {
      this.gridApi?.sizeColumnsToFit();
      this.gridApi?.refreshCells();
    }
  }

  cancelNullGuidAssume() {
    this.displayUnauthorized = false;
    this.displayScreen = true;
    localStorage.clear();
    location.reload();
  }

  ngOnDestroy(){
    this.checkValidity?.unsubscribe();
  }
}
